import { S } from '@/shared/constants/styles';
import { useIsMobile } from '@/shared/hooks/useMediaQuery';
import TransactionRow from './TransactionRow';
import SwipeableTransactionCard from './SwipeableTransactionCard';

const FULL_HEADERS = ["Date", "Description", "Category", "Group", "Amount", "Who", "Payment", "Notes", "Tags", ""];
const COMPACT_HEADERS = ["Date", "Description", "Category", "Amount", "Who", ""];

export default function TransactionList({
  transactions,
  onEdit, onDelete, onSplit, onDeleteAllSplits,
  deleteTxId, setDeleteTxId,
  incomeList, getGroup, currency,
  theme,
  emptyMessage = "No transactions",
  compact = false,
  anomalyMap = new Map(),
}) {
  const mobile = useIsMobile();
  const headers = compact ? COMPACT_HEADERS : FULL_HEADERS;

  if (transactions.length === 0) {
    return (
      <div style={{ color: theme.textMuted, textAlign: "center", padding: compact ? 40 : 50, fontSize: 13 }}>
        {emptyMessage}
      </div>
    );
  }

  if (mobile) {
    return (
      <div>
        {transactions.map(t => (
          <SwipeableTransactionCard
            key={t.id}
            transaction={t}
            onEdit={onEdit}
            onDelete={onDelete}
            onSplit={onSplit}
            onDeleteAllSplits={onDeleteAllSplits}
            deleteTxId={deleteTxId}
            setDeleteTxId={setDeleteTxId}
            incomeList={incomeList}
            currency={currency}
            theme={theme}
            anomalyMap={anomalyMap}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="table-scroll">
      <table style={{ width: "100%", fontSize: 13, borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: compact ? undefined : theme.tableBg, borderBottom: "2px solid " + theme.cardBorder }}>
            {headers.map(h => <th key={h} style={S.th}>{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {transactions.map(t => (
            <TransactionRow
              key={t.id}
              transaction={t}
              onEdit={onEdit}
              onDelete={onDelete}
              onSplit={onSplit}
              onDeleteAllSplits={onDeleteAllSplits}
              deleteTxId={deleteTxId}
              setDeleteTxId={setDeleteTxId}
              incomeList={incomeList}
              getGroup={getGroup}
              currency={currency}
              theme={theme}
              compact={compact}
              anomalyMap={anomalyMap}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
